
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps } from 'next';
import Page from 'shared/components/Page';
import SaInfo from 'modules/saInfo';
function SAinfo(): JSX.Element {
    return (<Page withLatestReviews={false} withWidget={false}>
      <SaInfo />
    </Page>);
}
const getStaticProps: GetStaticProps = async () => ({ props: {} });
export default SAinfo;

    async function __Next_Translate__getStaticProps__196d3bd90b8__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/SA-info',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196d3bd90b8__ as getStaticProps }
  